import * as Effects from "redux-saga/effects";

import { PRIVATE_ALGO_PRODUCT_IDS } from "src/constants";
import * as ProductReleaseAction from "../actions/productReleaseAction";
import * as api from "../../api/productReleases";
import { showErrorMessage } from "./shared";

const call: any = Effects.call;
const put: any = Effects.put;
const takeEvery: any = Effects.takeEvery;
const all: any = Effects.all;
const fork: any = Effects.fork;

export function* getProductReleases(action: ReturnType<typeof ProductReleaseAction.getProductReleases.request>): any {
  try {
    const { productId, requireAuth = false } = action.payload;
    const response = yield call(api.getProductReleases, productId, requireAuth);
    yield put(ProductReleaseAction.getProductReleases.success(response));
  } catch (error: any) {
    showErrorMessage(error);
    yield put(ProductReleaseAction.getProductReleases.failure(error));
  }
}

export function* updateProductReleaseChangeLog(action: ReturnType<typeof ProductReleaseAction.updateProductReleaseChangeLog.request>): any {
  try {
    const { productId, releaseId, changeLog } = action.payload;
    const response = yield call(api.updateProductRelease, productId, releaseId, changeLog);
    yield put(ProductReleaseAction.updateProductReleaseChangeLog.success(response));
    // Refresh the product releases list after update
    const requireAuth = PRIVATE_ALGO_PRODUCT_IDS.has(productId);
    yield put(ProductReleaseAction.getProductReleases.request({ productId, requireAuth }));
  } catch (error: any) {
    showErrorMessage(error);
    yield put(ProductReleaseAction.updateProductReleaseChangeLog.failure(error));
  }
}

/*
 * WATCHERS
 */

export function* watchGetProductReleases() {
  yield takeEvery(ProductReleaseAction.getProductReleases.request, getProductReleases);
}

export function* watchUpdateProductReleaseChangeLog() {
  yield takeEvery(ProductReleaseAction.updateProductReleaseChangeLog.request, updateProductReleaseChangeLog);
}

export default function* root() {
  yield all([fork(watchGetProductReleases), fork(watchUpdateProductReleaseChangeLog)]);
}
